import * as ReactDOM from 'react-dom/client'
import {FirebaseContextProvider} from '@goschool/react-firebase'
import {CssBaseline, ThemeProvider} from '@mui/material'
import '@goschool/i18n'

import {AuthenticationContextProvider, UserContextProvider} from '@goschool/auth'
import {NotFound} from './app'
import {GoSchoolRoutes} from '@goschool/site'

import * as Sentry from '@sentry/react'
import {goSchoolTheme} from './theme'
import './theme/fonts'
import {ConfirmationProvider, CustomGoSchoolContextProvider} from '@goschool/components'
import {BrowserRouter} from 'react-router-dom'
import {customAuth, firebaseConfig, goSchoolConfig, sentryConfig} from './config'
import {LandingPage} from './app/LandingPage'

if (sentryConfig) {
  Sentry.init(sentryConfig)
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
)

root.render(<AppTree/>)


function AppTree() {
  return <CustomGoSchoolContextProvider {...goSchoolConfig}>
    <ThemeProvider theme={goSchoolTheme}>
      <CssBaseline/>
      <FirebaseContextProvider options={firebaseConfig}>
        <UserContextProvider>
          <BrowserRouter>
            <AuthenticationContextProvider
              customConfigs={customAuth}
              enabledMethods={['credentials', 'google', 'microsoft']}>
              <ConfirmationProvider>
                <GoSchoolRoutes App={LandingPage} NotFound={NotFound}/>
              </ConfirmationProvider>
            </AuthenticationContextProvider>
          </BrowserRouter>
        </UserContextProvider>
      </FirebaseContextProvider>
    </ThemeProvider>
  </CustomGoSchoolContextProvider>

}

